import { TabWithFolders } from "api/course-resources";
import { PaziaButton } from "components/atoms";
import { useState } from "react";
import { DragDropContext, Draggable, DropResult, Droppable } from "react-beautiful-dnd";
import { FaPlus } from "react-icons/fa";
import { ResourceTabIcons } from "./ClientIconsDropdown";

interface DraggableReosurceListProps {
  tabs: TabWithFolders[];
  onAddTabClick: () => void;
  activeTabId?: number;
  onTabClick: (tab: TabWithFolders) => void;
}
export const DraggableReosurceList = ({
  tabs: initialTabs,
  onAddTabClick,
  activeTabId,
  onTabClick,
}: DraggableReosurceListProps) => {
  const [tabs, setTabs] = useState<TabWithFolders[]>(initialTabs);

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const updatedTabs = Array.from(tabs);
    const [movedTab] = updatedTabs.splice(result.source.index, 1);
    updatedTabs.splice(result.destination.index, 0, movedTab);

    setTabs(updatedTabs);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="tabs" direction="horizontal">
        {(provided) => (
          <ul
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="no-scrollbar relative flex flex-nowrap justify-between overflow-x-scroll text-sm font-medium md:justify-start"
          >
            {tabs.map((tab, index) => (
              <Draggable key={tab.name} draggableId={tab.name} index={index}>
                {(provided) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="px-4 py-2"
                    onClick={() => onTabClick(tab)}
                  >
                    <span
                      className={`flex gap-2 ${tab.id === activeTabId ? "" : "cursor-pointer"} ${
                        tab.id === activeTabId
                          ? "text-primary-500 border-primary-500 block whitespace-nowrap border-b-2 pb-3"
                          : "block whitespace-nowrap pb-3 text-slate-500 hover:text-slate-600 dark:text-slate-400 dark:hover:text-slate-300"
                      }`}
                    >
                      {ResourceTabIcons[tab.icon]}
                      {tab.name}
                    </span>
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
            <li className="cursor-pointer px-4 py-2 opacity-50 hover:opacity-80" onClick={onAddTabClick}>
              <span className="flex gap-2">Nowa zakładka...</span>
            </li>
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  );
};
